import { useAuth } from 'contexts/AuthContext';

export type PricingSession = {
  /** Changes on login/logout — use in fetch effect deps. */
  pricingAuthKey: string;
  /** False while restoring session from storage; avoid guest-priced fetches until true. */
  isAuthReady: boolean;
};

/**
 * Auth session state for customer-specific product pricing refetches.
 */
export function usePricingSession(): PricingSession {
  const { isAuthenticated, user, isLoading } = useAuth();

  return {
    pricingAuthKey: isAuthenticated && user?.id ? `customer-${user.id}` : 'guest',
    isAuthReady: !isLoading,
  };
}

/** @deprecated Prefer usePricingSession().pricingAuthKey */
export function usePricingAuthKey(): string {
  return usePricingSession().pricingAuthKey;
}
